var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0835 27.9166L16.7079 26.138C17.0037 26.0242 17.1516 25.9673 17.2899 25.8931C17.4128 25.8271 17.53 25.751 17.6402 25.6654C17.7643 25.5692 17.8763 25.4571 18.1004 25.233L27.5002 15.8333C28.4207 14.9128 28.4207 13.4204 27.5002 12.4999C26.5797 11.5795 25.0873 11.5795 24.1669 12.4999L14.7671 21.8997C14.543 22.1238 14.4309 22.2358 14.3347 22.3599C14.2491 22.4701 14.173 22.5873 14.107 22.7102C14.0328 22.8485 13.9759 22.9964 13.8621 23.2922L12.0835 27.9166ZM12.0835 27.9166L13.7986 23.4574C13.9213 23.1383 13.9827 22.9787 14.0879 22.9057C14.1799 22.8418 14.2937 22.8176 14.4037 22.8386C14.5296 22.8627 14.6505 22.9836 14.8922 23.2253L16.7748 25.1079C17.0166 25.3496 17.1374 25.4705 17.1615 25.5964C17.1825 25.7064 17.1583 25.8202 17.0945 25.9122C17.0214 26.0174 16.8618 26.0788 16.5427 26.2015L12.0835 27.9166Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.173122e40d06f6440d25bc44b4db5e6b.svg";
export { ForwardRef as ReactComponent };